<template>
  <div 
    class="stat-widget"
    :class="{'date-filtered': dateFiltered}">
    <label>{{ title }}</label>
    <h1>{{ value }}</h1>
    
    <div class="stat-widget-footer">
      <label>PEAK: </label>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Widget',

  props: {
    title: {
      type: String,
      required: true,
    },
    dateFiltered: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.stat-widget {
  width: 280px;
  height: 223px;
  background: $sec2;
  border-radius: $border-radius;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  label {
    color: #FFF;
    text-transform: uppercase;
    font-weight: bold;
    font-size: $font-size-medium;
  }
  
  h1 {
    color: #FFF;
    padding: 0;
    margin: 0;
    font-size: 48px;
  }

  .stat-widget-footer {
    background: #2e2f34;
    height: 20px;
    width: 100%;
    position: absolute;
    bottom: 0;

    label {
      font-size: $font-size-small;
      font-weight: normal;
      opacity: 0.6;
      padding: 0 $spacing-small;
    }
  }
}

.date-filtered {
  background: $blue;

  .stat-widget-footer {
    background: #074783;
  }
}
</style>